namespace advisorop.components.servicer {

    export class AdvisorListController {
        //public advisorId: number;
        public advisors;
        public dg: DevExpress.ui.dxDataGridOptions;

        user: domains.identity.IUser;
        servicer: any;

        static $inject = ["servicerService", "identityService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private identityService: services.IdentityService,
            private generalService: services.GeneralService) {

            this.servicer = domains.SystemLoginType.SERVICER;

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Advisors"
                },
                bindingOptions: {
                    dataSource: "vm.advisors"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                height: "600px",
                //paging: {
                //    pageSize: 15,
                //    enabled: true
                //},
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                width: "100%",
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'fullName', caption: 'Name', cellTemplate: 'colFullName', width: 140, sortIndex: 0, sortOrder: "asc" },
                    { dataField: 'actions', caption: 'Actions', cellTemplate: 'btnActions', width: 260 },
                    { dataField: 'repNumber', caption: 'Rep Num.', width: 70 },
                    { dataField: 'tinForPublic', caption: 'TIN/SSN', width: 140, visible: false },
                    { dataField: 'fullAddress', caption: 'Address', width: 200, visible: false },
                    { dataField: 'companyGroup.companyName', caption: 'Firm', visible: false },
                    { dataField: 'contactFullName', caption: 'Contact', visible: false },
                    { dataField: 'contactEmail', caption: 'E-mail', visible: false },
                    { dataField: 'systemLogin.username', caption: 'Username', visible: true, width: 125 },
                    { dataField: 'systemLogin.role', caption: 'Role', visible: true, width: 110 },
                    { dataField: 'systemLogin.loginStatusDesc', caption: 'Login stat.', visible: true, width: 80 },
                    { dataField: 'systemLogin.twoFactorEnabled', caption: '2FA', visible: true, width: 85, dataType: 'boolean', cellTemplate: 'colTwoFactor' },
                    { dataField: 'systemLogin.ssoMode', caption: 'Login Option', visible: true, width: 155, cellTemplate: 'colSsoMode',
                      lookup: { dataSource: advisorop.identity.SsoModeOption.all(), valueExpr: 'value', displayExpr: 'label' } },
                    {
                        caption: 'Last Login', visible: true, dataType: 'date', format: 'MM/dd/yy hh:mm a', width: 125,
                        allowSorting: true, allowFiltering: true,
                        calculateCellValue: function (advisor) {
                            if (!advisor.systemLogin) {
                                return "";
                            }
                            if (!advisor.systemLogin.lastLogin) {
                                return "";
                            }
                            return new Date(generalService.toUTCDateString(advisor.systemLogin.lastLogin));
                        }
                    }
                ],
                //selection: {
                //    mode: 'single',
                //    showCheckBoxesMode: 'onClick'
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onAdvisorChanged({ id: data.id });
                //    }
                //}
            };




        }

        currentAdvisor: domains.IAdvisor;

        // /////////////////////////////////////////////////////////
        // Advisor system login methods

        enableSL(advisor: domains.IAdvisor): void {
            this.servicerService.enableAdvisorSL(advisor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 4;
                    //investor.systemLogin.loginStatusDesc = "SETUP";
                    advisor.systemLogin = (<domains.IAdvisor>response.data).systemLogin;
                    toastr.success("Activation email sent to advisor at " + (<domains.IAdvisor>response.data).contactEmail + ".");
                }, err => this.generalService.showError(err));
        };

        reactivateSL(advisor: domains.IAdvisor): void {
            this.servicerService.reactivateAdvisorSL(advisor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 4;
                    //investor.systemLogin.loginStatusDesc = "SETUP";
                    advisor.systemLogin = (<domains.IAdvisor>response.data).systemLogin;
                    toastr.success("Reactivation email sent to advisor at " + (<domains.IAdvisor>response.data).contactEmail + ".");
                }, err => this.generalService.showError(err));
        };

        disableSL(advisor: domains.IAdvisor): void {
            this.servicerService.disableAdvisorSL(advisor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 3;
                    //investor.systemLogin.loginStatusDesc = "CANCELED";
                    advisor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success("User system login canceled.");
                }, err => this.generalService.showError(err));
        };

        lockSL(advisor: domains.IAdvisor): void {
            this.servicerService.lockAdvisorSL(advisor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 2;
                    //investor.systemLogin.loginStatusDesc = "LOCKED";
                    advisor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success("User system login locked.");
                }, err => this.generalService.showError(err));
        };

        unlockSL(advisor: domains.IAdvisor): void {
            this.servicerService.unlockAdvisorSL(advisor)
                .then(response => {
                    advisor.systemLogin.loginStatus = 1;
                    advisor.systemLogin.loginStatusDesc = "ACTIVE";
                    toastr.success("User system login unlocked.");
                }, err => this.generalService.showError(err));
        }

        okToImpersonateAdvisor(advisor: domains.IAdvisor): boolean {
            // Advisory admins can only be impersonated by servicer admins
            //if ((advisor.systemLogin
            //    && advisor.systemLogin.role == domains.AdvisoryRoles.ADVISORY_ADMIN.toString()
            //    && !this.isServicerAdmin()) || (advisor.systemLogin && advisor.systemLogin.loginStatus != 1))

            // We will currently allow any type of servicer to impersonate any advisor.
            // An advisor whose login was never created has nothing to impersonate.
            if (!advisor.systemLogin || advisor.systemLogin.loginStatus != 1)
                return false;
            else
                return true;
        }
        private impersonateAdvisorAt(advisor: domains.IAdvisor, confirmationMsg: string, landingPage: string): void {
            if (this.okToImpersonateAdvisor(advisor)) {
                if (window.confirm(confirmationMsg)) {
                    // authenticate servicer as advisor 
                    this.identityService.impersonateUser(advisor.systemLogin.username)
                        .then(response => {
                            // clear localstorage
                            localStorage.clear();
                            // redirect page to advisor dashboard
                            window.location.href = landingPage;
                        }).catch(err => toastr.error(`Error ${err.status} ${err.data}`))
                }
            } else {
                if (!advisor.systemLogin) {
                    toastr.warning("This advisor has no login yet. Open the advisor, check the email address and save to create one.");
                } else if (advisor.systemLogin.loginStatus != 1) {
                    toastr.warning("You can only impersonate users with ACTIVE Login Status.");
                } else {
                    toastr.warning("You can not impersonate this user.");
                }
            }
        }

        impersonateAdvisor(advisor: domains.IAdvisor): void {
            this.impersonateAdvisorAt(advisor, `Impersonate ${advisor.fullName}?`, "/advisor/dashboard");
        }

        openNewAccount(advisor: domains.IAdvisor): void {
            this.impersonateAdvisorAt(advisor, `Start opening a new account for ${advisor.fullName}?`, "/advisor/newnewaccount");
        }

        getAdvisors(id: number): void {
            this.servicerService.getAdvisors(id)
                .then(response => {
                    this.advisors = response.data;
                }, err => this.generalService.showError(err));
        };


        getAllAdvisors(): void {
            this.servicerService.getAllAdvisors()
                .then(response => {
                    // If this user is a servicer and is not SERVICER_ADMIN, then only show advisors (not advisor leads or advisor admins)
                    // This would be better filtered on the server in the future, for now is not a big issue...
                    //if (this.isServicerAdmin()) {
                    this.advisors = response.data;
                    //} else {
                    //    this.advisors = response.data.filter(f => f.systemLogin.role == domains.AdvisoryRoles.ADVISORY.toString());
                    //}
                }, err => this.generalService.showError(err));
        };

        isServicerAdmin(): boolean {
            return (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
        }

        /// Only shown where the deployment actually has Salesforce sign-in. One build serves every
        /// client, so an ungated control would offer fifteen of them a sign-in method they do not
        /// have.
        ssoEnabled: boolean = false;
        ssoModes = advisorop.identity.SsoModeOption.all();

        ssoModeLabel(mode: number): string {
            return advisorop.identity.SsoModeOption.label(mode);
        }
        /// What the value was before the select was touched. ng-model has already changed the row
        /// by the time ng-change fires, so a cancelled confirmation or a failed save needs this to
        /// put it back rather than leave the screen claiming something the server never accepted.
        private ssoModeBefore: number = null;

        rememberSsoMode(advisor: domains.IAdvisor): void {
            // The setting lives on the login, not the advisor record.
            this.ssoModeBefore = advisor.systemLogin ? (advisor.systemLogin.ssoMode || 0) : 0;
        }

        /// Changes how this login may authenticate. The server records who did it.
        setSsoMode(advisor: domains.IAdvisor): void {
            if (!advisor.systemLogin) {
                return;
            }

            const mode = advisor.systemLogin.ssoMode;
            const previous = this.ssoModeBefore;

            if (mode === previous) {
                return;
            }

            if (!advisorop.identity.SsoModeOption.confirm(mode, advisor.fullName)) {
                advisor.systemLogin.ssoMode = previous;
                return;
            }

            this.servicerService.setSsoModeAdvisorSL(advisor, mode)
                .success((data) => {
                    angular.copy(data, advisor);
                    toastr.success(advisorop.identity.SsoModeOption.message(mode, advisor.fullName));
                })
                .error((data, status) => {
                    advisor.systemLogin.ssoMode = previous;
                    toastr.error("Error " + status + " " + data);
                });
        };

        setTwoFactor(advisor: domains.IAdvisor, enabled: boolean): void {
            // Off is always for a stated number of days; the enforcement job switches it back on
            // when they run out, so the administrator is told the date rather than left to
            // remember. See advisorop.identity.TwoFactorExemption for the wording and the range.
            let days: number = null;
            if (!enabled) {
                days = advisorop.identity.TwoFactorExemption.promptForDays(advisor.fullName);
                if (days === null)
                    return;
            }

            this.servicerService.setTwoFactorAdvisorSL(advisor, enabled, days)
                .then(response => {
                    advisor.systemLogin = (<domains.IAdvisor>response.data).systemLogin;
                    toastr.success(enabled
                        ? "Two-factor authentication turned on."
                        : advisorop.identity.TwoFactorExemption.offMessage(advisor.fullName, days));
                }, err => this.generalService.showError(err));
        };

        $onInit(): void {
            this.identityService.getSsoConfig().then((response: any) => {
                this.ssoEnabled = !!(response.data && response.data.enabled);
            }, () => { this.ssoEnabled = false; });

            this.identityService.getUserPromise().then(response => {
                this.user = response;
                // THIS IS NOT OK !!!!

                if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
                    this.currentAdvisor = this.user.advisor;
                };

                if (this.user.systemLoginType == this.servicer) {

                    this.getAllAdvisors();
                }
                else {
                    this.getAdvisors(this.currentAdvisor.companyGroup.id);
                }

            });

        }

    }

    class AdvisorList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                // still need to restrict access based on firm...
                //advisorId: "<"
            };
            this.controller = AdvisorListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/advisor-list.html';
        }
    }
    angular.module(Constants.APP).component("advisorList", new AdvisorList());

}